<div class="diagram mt-5">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 567 537.5">
    <g id="Major_Options" data-name="Major Options" transform="translate(-451 -112.5)">
      <g id="Group_1223" data-name="Group 1223" transform="translate(-10542.21 -1920.438)">
        <g id="Group_1219" data-name="Group 1219" transform="translate(11068.619 1888.733)">
          <path
            id="Path_1041"
            data-name="Path 1041"
            d="M465.321,522.69s-5.043-1.224-6.991,3.289-13.957,59.191-13.284,95.849l12.052-6.67s7.231-1.625,9.192-3.923Z"
            transform="translate(-195.934 -172.115)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1042"
            data-name="Path 1042"
            d="M446.516,644.575s9.342-5.306,10.313-7.623.855-62.554.855-62.554l-4.307,3.738s-7.466,35.648-8.21,66.439v.729Z"
            transform="translate(-196.021 -202.634)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1043"
            data-name="Path 1043"
            d="M469.063,539.834l.364,14.223-4.308,3.738Z"
            transform="translate(-207.763 -182.293)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1044"
            data-name="Path 1044"
            d="M493.833,702.236s-1.7,1.458-1.85.971c-.058-.187-.126-2.89-.153-6.24-.042-5.331.024-12.3.414-13.378,1.009-1.346,1.356.971,1.356.971Z"
            transform="translate(-223.476 -266.648)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1045"
            data-name="Path 1045"
            d="M491.846,702.808l1.922-.878-.1-7.642-1.734-1.194Z"
            transform="translate(-223.492 -272.489)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1046"
            data-name="Path 1046"
            d="M445.085,748.682c.341.008-.72,71.6,3.625,75.633H459.1s6-6.016,7.15-12.742.081-73.484.081-73.484-2.3,2.41-9.192,3.923Z"
            transform="translate(-195.972 -298.969)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1047"
            data-name="Path 1047"
            d="M445.3,773.053l10.714-3.771-2.557,45.14-7.6,2.075Z"
            transform="translate(-196.097 -317.327)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1048"
            data-name="Path 1048"
            d="M446.826,885.448l7.617-2.469S453.43,898,452.4,899.2l-4.637,1.438Z"
            transform="translate(-196.997 -384.239)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1049"
            data-name="Path 1049"
            d="M487.714,885.988s1.345.822,1.569-4.6,0-10.874,0-10.874-.15-3.55-.971-3.849-1.271,1.233-1.271,1.233v17.264S487.1,886.157,487.714,885.988Z"
            transform="translate(-220.664 -374.618)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1050"
            data-name="Path 1050"
            d="M488.414,885.667l-1.373,1.233v-9.006l1.373.654Z"
            transform="translate(-220.664 -381.247)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1051"
            data-name="Path 1051"
            d="M453.894,702.38s8.288,1.756,10.123-82.677-.463-88.8-.463-88.8"
            transform="translate(-201.157 -177.034)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1052"
            data-name="Path 1052"
            d="M456.462,524.993s-.575-41.927,0-45.983-1.7-90.749-1.7-90.749c-1.345-62.518-20.852-93.885-20.852-93.885"
            transform="translate(-189.399 -37.837)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1053"
            data-name="Path 1053"
            d="M488.626,522.66s-2.582-.544-4.008.3l1.474,63.632.3,15.083-.011,9.463-.082,2.12s-.29,9.353-.25,17.34.25,29.427.25,29.427l3.743-.28Z"
            transform="translate(-219.238 -172.084)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1054"
            data-name="Path 1054"
            d="M481.124,583.431s13,9.641,14.8,9.267,4.111-4.409-1.794-11.808-10.538-6.726-10.538-6.726S479.854,572,481.124,583.431Z"
            transform="translate(-217.027 -202.4)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <g
            id="Path_1055"
            data-name="Path 1055"
            transform="translate(-53.909 -2.484)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M297.3,251.755s-5.153-9.267-49.4-9.267c-37.557.71-44.213,8.805-44.213,8.805,3.34-4.463,7.008-9.269,11.559-12.427s10.528-3.317,15.867-3.605c11.354-.612,22.95-1.252,34.414-.81,8.146.314,18.023.6,23.829,7.244A122.917,122.917,0,0,1,297.3,251.755Z"
              stroke="none"
            />
            <path
              d="M 206.0462341308594 249.0094909667969 C 207.3058929443359 248.3160858154297 209.0865631103516 247.5039825439453 211.5582427978516 246.6828002929688 C 215.2780151367188 245.4469451904297 219.8280181884766 244.4329376220703 225.0818481445312 243.6689300537109 C 231.6334838867188 242.7162017822266 239.3096160888672 242.1508483886719 247.8970336914062 241.9885406494141 C 247.9001922607422 241.9884948730469 247.9033203125 241.9884490966797 247.9064788818359 241.9884490966797 C 257.1941223144531 241.9884490966797 265.4728088378906 242.4010772705078 272.5126342773438 243.2148590087891 C 278.3047180175781 243.8844299316406 283.3080444335938 244.8299865722656 287.3836059570312 246.0252838134766 C 290.7564392089844 247.0144653320312 293.0626220703125 248.0422058105469 294.6284484863281 248.9423522949219 C 292.878662109375 246.6320953369141 290.9894104003906 244.3154296875 288.9862670898438 242.0246429443359 C 286.507568359375 239.1898803710938 283.0401000976562 237.2934875488281 278.3857727050781 236.2270812988281 C 274.2835998535156 235.2872009277344 269.8020935058594 235.1153717041016 265.8481140136719 234.9637756347656 L 265.5144348144531 234.9509735107422 C 262.9596557617188 234.8525848388672 260.353271484375 234.8047637939453 257.5463256835938 234.8047637939453 C 248.8692474365234 234.8047637939453 240.0830383300781 235.2787322998047 231.5861053466797 235.7371063232422 L 231.1461334228516 235.7608337402344 C 230.8703765869141 235.7757263183594 230.5929565429688 235.7902374267578 230.3141632080078 235.8048248291016 C 227.755615234375 235.9387054443359 225.1099548339844 236.0771484375 222.5643615722656 236.5528106689453 C 219.7103729248047 237.0860900878906 217.4118347167969 237.9774475097656 215.5373992919922 239.2777862548828 C 211.8520965576172 241.8345336914062 208.7069244384766 245.5533599853516 206.0462341308594 249.0094909667969 M 297.3047180175781 251.7554473876953 C 297.2559509277344 251.6862640380859 297.207275390625 251.6174011230469 297.1583557128906 251.5483093261719 C 297.2638854980469 251.6820220947266 297.3047180175781 251.7554473876953 297.3047180175781 251.7554473876953 Z M 297.1583557128906 251.5483093261719 C 296.0780334472656 250.1794586181641 288.2147521972656 242.4884490966797 247.9064788818359 242.4884490966797 C 210.3495635986328 243.1982421875 203.6929931640625 251.2937927246094 203.6929931640625 251.2937927246094 C 207.0334320068359 246.8308258056641 210.7013702392578 242.0243072509766 215.2523803710938 238.8669738769531 C 219.8136901855469 235.7026519775391 225.7801971435547 235.5496063232422 231.1191864013672 235.2615661621094 C 239.8416442871094 234.7911834716797 248.7071838378906 234.3047485351562 257.5463256835938 234.3047485351562 C 260.2127380371094 234.3047485351562 262.876708984375 234.3490142822266 265.5336608886719 234.4513397216797 C 273.6798095703125 234.764892578125 283.5562133789062 235.0549926757812 289.3626708984375 241.6955261230469 C 292.1149597167969 244.8430328369141 294.7401123046875 248.1343383789062 297.1583557128906 251.5483093261719 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_1056"
            data-name="Path 1056"
            transform="translate(-23.875 -12.863)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M152.925,297.5s14.139-31.018,29.042-45.562C181.967,251.941,149.412,262.621,152.925,297.5Z"
              stroke="none"
            />
            <path
              d="M 153.2681884765625 295.5966186523438 C 154.6085357666016 292.787353515625 157.5490417480469 286.7987976074219 161.4217376708984 279.9306945800781 C 164.5630645751953 274.3596496582031 167.6949920654297 269.3065490722656 170.7305145263672 264.9118347167969 C 173.9256286621094 260.2860412597656 177.0223541259766 256.380859375 179.9608459472656 253.2696380615234 C 179.1871032714844 253.6054534912109 178.2373809814453 254.0455627441406 177.1644744873047 254.5990905761719 C 172.2589111328125 257.1299438476562 168.6389007568359 260.0263061523438 166.4659118652344 262.0104064941406 C 162.0479736328125 266.0442810058594 158.6746826171875 270.7062377929688 156.4397277832031 275.8667907714844 C 153.8660888671875 281.8093566894531 152.8015594482422 288.438232421875 153.2681884765625 295.5966186523438 M 152.9248809814453 297.5033264160156 C 149.4124603271484 262.6206359863281 181.9669952392578 251.9410095214844 181.9669952392578 251.9410095214844 C 167.0638732910156 266.4852905273438 152.9248809814453 297.5033264160156 152.9248809814453 297.5033264160156 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_1057"
            data-name="Path 1057"
            transform="translate(-175.514 -12.376)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M439.25,296.091s-14.024-30.434-28.927-44.978C410.323,251.113,442.763,261.208,439.25,296.091Z"
              stroke="none"
            />
            <path
              d="M 438.9057006835938 294.201171875 C 439.3751220703125 287.0505065917969 438.3203125 280.4534912109375 435.7629699707031 274.568359375 C 433.5430603027344 269.459716796875 430.1903991699219 264.8672790527344 425.7981262207031 260.9186096191406 C 421.880615234375 257.3967895507812 417.8434753417969 255.0488433837891 415.1465454101562 253.6993408203125 C 414.041015625 253.1461334228516 413.0640563964844 252.7108154296875 412.2752990722656 252.3829803466797 C 415.2276611328125 255.4949188232422 418.3363647460938 259.3890686035156 421.5404052734375 263.9910888671875 C 424.5663757324219 268.3372497558594 427.6849670410156 273.3226928710938 430.8096008300781 278.8088989257812 C 434.6555786132812 285.5616149902344 437.5723876953125 291.4371337890625 438.9057006835938 294.201171875 M 439.2499084472656 296.0914306640625 C 439.2499084472656 296.0914306640625 425.2261047363281 265.6573181152344 410.322998046875 251.1130065917969 C 410.322998046875 251.1130065917969 442.7627258300781 261.2083435058594 439.2499084472656 296.0914306640625 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_1058"
            data-name="Path 1058"
            transform="translate(-29.867 -2.544)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M162.84,355.2s5.425-87.1,32.85-118.411c0,0,6.05-2.017,28.174-2.259,13.282-.169,27.5-.636,34.633,2.516,6.823,4.706,25.1,45.486,29.984,99.331l2.195,18.421s-2.317-1.271-3.812-.822c0,0,1.858-8.672-1.276-12.108-.667-.732-1.262-1.524-1.946-2.241a19.452,19.452,0,0,0-3.619-2.947,34.415,34.415,0,0,0-6.747-3.22,77.878,77.878,0,0,0-11.338-3.07,174.255,174.255,0,0,0-17.392-2.5,200.588,200.588,0,0,0-27.164-1.2,154.138,154.138,0,0,0-21.615,2.163,76.821,76.821,0,0,0-14.6,3.968,38.148,38.148,0,0,0-8.965,4.838,20.626,20.626,0,0,0-4.7,4.773,12.812,12.812,0,0,0-1.81,3.772,8.188,8.188,0,0,0-.272,1.411,18.615,18.615,0,0,0,.747,6.427Z"
              stroke="none"
            />
            <path
              d="M 163.3904113769531 354.4842224121094 L 165.5536499023438 353.7369079589844 C 165.2731018066406 352.6990051269531 164.6790466308594 350.1140747070312 164.9205932617188 347.5799865722656 C 164.9652099609375 347.1093444824219 165.0592651367188 346.6195678710938 165.2080841064453 346.0828552246094 C 165.5693664550781 344.7772521972656 166.2014312744141 343.4580078125 167.0866851806641 342.1618041992188 C 168.2710113525391 340.4268798828125 169.8902893066406 338.7813110351562 171.8996429443359 337.2707824707031 C 174.3876190185547 335.4012145996094 177.3581695556641 333.79736328125 180.9810485839844 332.3675842285156 C 185.2071533203125 330.69970703125 190.0147552490234 329.392822265625 195.6786499023438 328.3722534179688 C 202.10205078125 327.21484375 209.1952514648438 326.5047912597656 217.3636322021484 326.2015380859375 C 218.9977569580078 326.1408996582031 220.6962738037109 326.1101379394531 222.4120330810547 326.1101379394531 C 230.5078430175781 326.1101379394531 238.5198516845703 326.7997741699219 244.5953979492188 327.4005737304688 C 251.3492584228516 328.0681457519531 256.8916015625 328.8635559082031 262.0374450683594 329.9036865234375 C 266.5499267578125 330.8154907226562 270.1757507324219 331.7974243164062 273.4480895996094 332.9938659667969 C 276.2050170898438 334.0015563964844 278.3799743652344 335.0400085449219 280.2927551269531 336.2620544433594 C 281.7003173828125 337.1614685058594 282.9490661621094 338.1784973144531 284.0045166015625 339.2850036621094 C 284.3932189941406 339.6929321289062 284.7548522949219 340.1251525878906 285.1045532226562 340.5431518554688 C 285.3807373046875 340.8732604980469 285.6663513183594 341.2146301269531 285.9578857421875 341.5343933105469 C 288.726806640625 344.5705261230469 287.8624572753906 351.2033996582031 287.4853820800781 353.385009765625 C 287.5171813964844 353.3841552734375 287.5491943359375 353.3837280273438 287.5815124511719 353.3837280273438 C 288.4639892578125 353.3837280273438 289.4132385253906 353.6961669921875 290.0727844238281 353.9683837890625 L 287.9842224121094 336.4404602050781 C 287.9836730957031 336.435791015625 287.9831848144531 336.43115234375 287.9827575683594 336.4264526367188 C 286.842041015625 323.8519287109375 284.8984680175781 311.2306518554688 282.2060546875 298.9132080078125 C 279.8673400878906 288.2139282226562 277.0199584960938 277.9649963378906 273.7429809570312 268.4510498046875 C 267.4745483398438 250.2518920898438 261.3311157226562 239.6640014648438 258.2510681152344 237.4879913330078 C 253.0591888427734 235.2141571044922 243.9645538330078 234.9070434570312 235.7473602294922 234.9070434570312 C 232.8327178955078 234.9070434570312 229.8022918701172 234.9504089355469 226.8716583251953 234.9923553466797 C 225.8680725097656 235.0067291259766 224.8664245605469 235.0210571289062 223.8692932128906 235.0337219238281 C 212.5267333984375 235.1577758789062 205.5148620605469 235.7577819824219 201.6299438476562 236.2392578125 C 198.0707702636719 236.6803741455078 196.4114685058594 237.1055297851562 195.9712219238281 237.2304382324219 C 189.7969665527344 244.322998046875 184.2427673339844 254.8974914550781 179.4612121582031 268.663818359375 C 175.6075592041016 279.7587280273438 172.2473907470703 292.933349609375 169.4740905761719 307.8216552734375 C 165.2410583496094 330.5464477539062 163.6794586181641 350.432861328125 163.3904113769531 354.4842224121094 M 162.8399810791016 355.203369140625 C 162.8399810791016 355.203369140625 168.2649993896484 268.1067199707031 195.6895599365234 236.7928314208984 C 195.6895599365234 236.7928314208984 201.7400360107422 234.7757263183594 223.8638305664062 234.5337524414062 C 227.8118743896484 234.4836120605469 231.8445739746094 234.4070434570312 235.7473602294922 234.4070434570312 C 244.974609375 234.4070434570312 253.4846343994141 234.8346252441406 258.4971618652344 237.0499877929688 C 265.3200073242188 241.7557067871094 283.5960083007812 282.5357666015625 288.480712890625 336.3812866210938 L 290.6756286621094 354.8017883300781 C 290.6756286621094 354.8017883300781 289.0015258789062 353.8837585449219 287.5815124511719 353.8837585449219 C 287.3308715820312 353.8837585449219 287.0882568359375 353.9123229980469 286.8640441894531 353.9796142578125 C 286.8640441894531 353.9796142578125 288.7222900390625 345.3075866699219 285.5884399414062 341.8713073730469 C 284.9214477539062 341.1397094726562 284.3263854980469 340.3475952148438 283.6425476074219 339.6299438476562 C 282.5640258789062 338.4992370605469 281.3390502929688 337.5239868164062 280.0235290527344 336.683349609375 C 277.9192199707031 335.3389892578125 275.616943359375 334.3189392089844 273.2764282226562 333.4634704589844 C 269.5961608886719 332.1178894042969 265.7750854492188 331.1690368652344 261.9384155273438 330.393798828125 C 256.1957702636719 329.2330017089844 250.3740844726562 328.4742126464844 244.5462188720703 327.8981628417969 C 237.1893310546875 327.170654296875 229.8043212890625 326.6101379394531 222.4120330810547 326.6101379394531 C 220.7354125976562 326.6101379394531 219.0594177246094 326.6389465332031 217.3821563720703 326.701171875 C 210.1457977294922 326.9698486328125 202.8991851806641 327.5792541503906 195.7673187255859 328.8643188476562 C 190.8027801513672 329.7588806152344 185.8637390136719 330.9780883789062 181.1645965576172 332.8326721191406 C 178.00439453125 334.0798645019531 174.9232177734375 335.6241760253906 172.2000122070312 337.6705017089844 C 170.4113006591797 339.0151977539062 168.7653656005859 340.5895385742188 167.4996337890625 342.4436950683594 C 166.7116394042969 343.5974731445312 166.0635681152344 344.8660888671875 165.6899566650391 346.2161865234375 C 165.5619659423828 346.6778564453125 165.4636077880859 347.1498413085938 165.4183654785156 347.6271667480469 C 165.1192016601562 350.7659301757812 166.1656188964844 354.0545043945312 166.1656188964844 354.0545043945312 L 162.8399810791016 355.203369140625 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <path
            id="Path_1059"
            data-name="Path 1059"
            d="M198.48,282.851"
            transform="translate(-50.841 -31.054)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <g
            id="Path_1060"
            data-name="Path 1060"
            transform="translate(-26.995 -31.054)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M157.961,311.776s10.107-20.436,16.673-28.925a17.593,17.593,0,0,0-6.093,4.589C164.829,291.44,160.173,299.1,157.961,311.776Z"
              stroke="none"
            />
            <path
              d="M 159.1726531982422 308.2754211425781 C 162.0532684326172 302.6598510742188 168.1277008056641 291.1531066894531 172.9165496826172 284.3438415527344 C 171.8590545654297 285.0318603515625 170.4452972412109 286.1231689453125 168.9075775146484 287.7799987792969 C 167.4251861572266 289.3774108886719 165.2212371826172 292.1990661621094 163.1400146484375 296.5699157714844 C 161.4790344238281 300.0582275390625 160.1494598388672 303.9833679199219 159.1726531982422 308.2754211425781 M 157.9609985351562 311.7762451171875 C 160.1731414794922 299.1012878417969 164.8290557861328 291.4399108886719 168.5410766601562 287.4398803710938 C 171.8831329345703 283.8389892578125 174.6338958740234 282.8510131835938 174.6338958740234 282.8510131835938 C 168.0678558349609 291.3399353027344 157.9609985351562 311.7762451171875 157.9609985351562 311.7762451171875 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_1061"
            data-name="Path 1061"
            transform="translate(-26.995 -45.249)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M157.961,325.971s.972-14.657,4.335-18.918l2.292-.083S158.532,319.007,157.961,325.971Z"
              stroke="none"
            />
            <path
              d="M 159.4006652832031 317.9516296386719 C 159.8627166748047 316.6180114746094 160.40478515625 315.1896362304688 161.0258636474609 313.6698608398438 C 162.1366119384766 310.9518432617188 163.2230682373047 308.6380615234375 163.7722015380859 307.4999389648438 L 162.5516204833984 307.5441589355469 C 161.0412445068359 309.6341552734375 160.0364074707031 313.9937133789062 159.4006652832031 317.9516296386719 M 157.9609985351562 325.9706726074219 C 157.9609985351562 325.9706726074219 158.9329223632812 311.3132019042969 162.2959747314453 307.0531005859375 L 164.5883636474609 306.9700317382812 C 164.5883636474609 306.9700317382812 158.5317230224609 319.0071105957031 157.9609985351562 325.9706726074219 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_1062"
            data-name="Path 1062"
            transform="translate(-31.042 -37.617)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M172.588,294s-7.115,1.283-7.75,5.474l3.8-.138A24.3,24.3,0,0,1,172.588,294Z"
              stroke="none"
            />
            <path
              d="M 171.0524291992188 294.9113159179688 C 169.1735992431641 295.4906311035156 166.2411193847656 296.7281188964844 165.4791259765625 298.9529724121094 L 168.3343048095703 298.8493041992188 C 168.6920776367188 298.2132873535156 169.6977081298828 296.5094909667969 171.0524291992188 294.9113159179688 M 172.5882873535156 294.0029602050781 C 170.3296661376953 296.1534118652344 168.6355895996094 299.3386840820312 168.6355895996094 299.3386840820312 L 164.8379974365234 299.4765625 C 165.4729309082031 295.2859802246094 172.5882873535156 294.0029602050781 172.5882873535156 294.0029602050781 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <g
            id="Path_1063"
            data-name="Path 1063"
            transform="translate(-190.802 -31.053)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M436.3,282.849s12.92,2.913,15.834,27.183C452.134,310.032,437.785,283.524,436.3,282.849Z"
              stroke="none"
            />
            <path
              d="M 437.8612365722656 283.9895324707031 C 438.9822387695312 285.6517944335938 441.0889282226562 289.1177673339844 445.2100219726562 296.4485473632812 C 447.5666809082031 300.6407470703125 449.8695373535156 304.8342895507812 451.2555541992188 307.3720703125 C 450.5518188476562 303.0254821777344 449.4598999023438 299.1447448730469 447.9994201660156 295.8073120117188 C 446.5976867675781 292.6040954589844 444.8554077148438 289.8918151855469 442.8210144042969 287.7458190917969 C 441.015625 285.8413696289062 439.3087158203125 284.7440185546875 438.1946716308594 284.1588439941406 C 438.0796813964844 284.0984191894531 437.9683837890625 284.0420227050781 437.8612365722656 283.9895324707031 M 436.2999877929688 282.8489990234375 C 436.2999877929688 282.8489990234375 449.2197265625 285.7615051269531 452.13427734375 310.0320434570312 C 452.13427734375 310.0320434570312 437.7854309082031 283.5238342285156 436.2999877929688 282.8489990234375 Z"
              stroke="none"
              fill="#030504"
            />
          </g>
          <path
            id="Path_1064"
            data-name="Path 1064"
            d="M452.668,294.377s6.614,1.289,7.138,5.213l-3.569-.234S456.143,298.469,452.668,294.377Z"
            transform="translate(-200.435 -37.837)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1065"
            data-name="Path 1065"
            d="M468.179,326.255s-.254-16-4.643-19.543l-2.2-.234a39.647,39.647,0,0,1,5.007,15.947"
            transform="translate(-205.539 -44.958)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1066"
            data-name="Path 1066"
            d="M139.41,337.853l6.67-9.921s-1.934,8.324-.757,13.369l3.363-6.586.365,47.14s-1.916,9.193,6.329,17.825c-1.322-1.065-5.825-1.569-3,9.417,0,0-4.727,1.308-4.531,2.382,0,0-2.308-4.064-8.174-3.317Z"
            transform="translate(-16.078 -57.585)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1067"
            data-name="Path 1067"
            d="M472.153,338.094l-6.327-9.753s1.149,8.632.414,13.2l-3.363-6.586-.364,47.14s1.915,9.193-6.329,17.825c1.322-1.065,5.411-2.046,3.318,9.342,0,0,2.6-1.439,5.4,2.429,0,0,1.124-4.036,6.991-3.289Z"
            transform="translate(-202.504 -57.826)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1069"
            data-name="Path 1069"
            d="M170.207,486.463s1.5-.495,2.219-7.735c0,0,6.75-13.752,52.451-13.752s60.48,10.743,60.48,10.743a10.7,10.7,0,0,1,2.317,5.25,15.526,15.526,0,0,0,1.513,5.185s.541.551.934-.327,1.5-9.414-.993-12.138-8.474-14.123-64.7-15.248C167.4,458.922,165.013,481.493,170.207,486.463Z"
            transform="translate(-33.123 -134.392)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1070"
            data-name="Path 1070"
            d="M282.952,548.612l9.176-52.943a.579.579,0,0,1-.32-.166,15.358,15.358,0,0,1-1.513-5.185,10.8,10.8,0,0,0-2.317-5.25s-14.93-10.087-56.389-10.714-53.93,9.462-56.542,13.722c0,0-.668,6.913-2.219,7.735l9.23,52.8S223.537,536.5,282.952,548.612Z"
            transform="translate(-35.745 -143.74)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1071"
            data-name="Path 1071"
            d="M195.26,647.077s7.324,80.715,4.185,108.068c0,0,54.557,10.314,91.327,0,0,0,0-77.022,5.381-108.068,0,0-31.377-6.118-51.456-5.378C244.7,641.7,212.3,641.808,195.26,647.077Z"
            transform="translate(-48.946 -242.206)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1072"
            data-name="Path 1072"
            d="M445.019,778.545"
            transform="translate(-195.934 -322.778)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1073"
            data-name="Path 1073"
            d="M200.709,653.768s7.587,63.884,4.242,108.92"
            transform="translate(-52.153 -249.345)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1074"
            data-name="Path 1074"
            d="M427.96,653.945s-6.285,30.2-5.192,108.934"
            transform="translate(-182.764 -249.449)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1075"
            data-name="Path 1075"
            d="M138.655,522.652s5.043-1.224,6.991,3.288,13.957,59.191,13.284,95.849l-12.052-6.67s-7.231-1.626-9.192-3.924Z"
            transform="translate(-15.063 -172.092)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1076"
            data-name="Path 1076"
            d="M169.972,644.536s-9.342-5.306-10.313-7.623-.855-62.554-.855-62.554l4.307,3.738s7.466,35.648,8.21,66.439v.728Z"
            transform="translate(-27.489 -202.611)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1077"
            data-name="Path 1077"
            d="M159.174,539.795l-.364,14.223,4.308,3.738Z"
            transform="translate(-27.495 -182.27)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1078"
            data-name="Path 1078"
            d="M137.686,702.2s1.7,1.458,1.85.972c.058-.188.126-2.891.153-6.241.042-5.33-.024-12.3-.414-13.378-1.009-1.345-1.356.971-1.356.971Z"
            transform="translate(-15.063 -266.626)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1079"
            data-name="Path 1079"
            d="M139.8,702.77l-1.922-.878.1-7.642,1.734-1.194Z"
            transform="translate(-15.178 -272.466)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1080"
            data-name="Path 1080"
            d="M158.285,748.643c-.341.007.72,71.6-3.625,75.632H144.272s-6-6.016-7.15-12.742-.081-73.484-.081-73.484,2.3,2.41,9.192,3.924Z"
            transform="translate(-14.419 -298.946)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1081"
            data-name="Path 1081"
            d="M173.778,773.015l-10.714-3.771,2.557,45.141,7.6,2.075Z"
            transform="translate(-29.999 -317.304)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1082"
            data-name="Path 1082"
            d="M176.678,885.41l-7.617-2.469s1.013,15.022,2.038,16.218l4.637,1.437Z"
            transform="translate(-33.528 -384.217)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1083"
            data-name="Path 1083"
            d="M143.335,885.949s-1.345.822-1.569-4.6,0-10.874,0-10.874.15-3.55.971-3.849,1.271,1.233,1.271,1.233v17.264S143.951,886.118,143.335,885.949Z"
            transform="translate(-17.405 -374.595)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1084"
            data-name="Path 1084"
            d="M144.02,885.628l1.373,1.233v-9.006l-1.373.654Z"
            transform="translate(-18.791 -381.224)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1085"
            data-name="Path 1085"
            d="M165.01,702.341s-8.288,1.757-10.123-82.676.463-88.8.463-88.8"
            transform="translate(-24.768 -177.011)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1086"
            data-name="Path 1086"
            d="M145.555,524.954s.575-41.927,0-45.982,1.7-90.749,1.7-90.749c1.345-62.518,20.851-93.885,20.851-93.885"
            transform="translate(-19.639 -37.814)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1087"
            data-name="Path 1087"
            d="M138.01,522.622s2.582-.544,4.008.3l-1.474,63.631-.3,15.083.011,9.464.082,2.119s.29,9.353.25,17.34-.25,29.427-.25,29.427l-3.743-.28Z"
            transform="translate(-14.419 -172.062)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1088"
            data-name="Path 1088"
            d="M128.882,583.392s-13,9.641-14.8,9.267-4.111-4.409,1.794-11.808,10.538-6.727,10.538-6.727S130.152,571.958,128.882,583.392Z"
            transform="translate(0 -202.377)"
            fill="#fff"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1089"
            data-name="Path 1089"
            d="M452.02,927.713v0l-1.289,32.993s-7.735,28.81-14.91,30.268l1.233-19.02s.336-16.741-1.233-29.3-1.682-26.569-1.906-27.69l5.841-1.189s.737,13.221,2.493,13.931Z"
            transform="translate(-189.399 -402.367)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1090"
            data-name="Path 1090"
            d="M156.318,927.713v0l1.289,32.993s7.735,28.81,14.91,30.268l-1.233-19.02s-.336-16.741,1.233-29.3,1.681-26.569,1.906-27.69l-5.841-1.189s-.736,13.221-2.492,13.931Z"
            transform="translate(-26.028 -402.367)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1091"
            data-name="Path 1091"
            d="M292.055,917.488l4.11,54.184a246.038,246.038,0,0,1-50.185,5.007c-28.587,0-48.541-5.157-48.541-5.157l3.289-54.034s29.349,4.651,45.252,4.51A164.429,164.429,0,0,0,292.055,917.488Z"
            transform="translate(-50.229 -404.548)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1092"
            data-name="Path 1092"
            d="M390.341,896.786l-.332,50.67s-3.219,28.7-16.1,39.46-34.479,12.855-58.506,12.855"
            transform="translate(-119.654 -392.365)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1093"
            data-name="Path 1093"
            d="M136.591,896.786l.332,50.67s3.219,28.7,16.1,39.46,34.479,12.855,58.506,12.855"
            transform="translate(-14.419 -392.365)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1094"
            data-name="Path 1094"
            d="M453.457,1027.826l-.953,18.385a26.582,26.582,0,0,1-10.93,12.723l-3.027-.841S444.825,1058.43,453.457,1027.826Z"
            transform="translate(-192.125 -469.484)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1095"
            data-name="Path 1095"
            d="M159.444,1027.826l.953,18.385s1.453,6.173,11.064,12.687l2.893-.8S168.076,1058.43,159.444,1027.826Z"
            transform="translate(-27.868 -469.484)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1096"
            data-name="Path 1096"
            d="M180.5,1075.5s9.734,18.834,55.51,18.983c0,0,41.235,2.339,57.818-18.983"
            transform="translate(-40.262 -497.542)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1097"
            data-name="Path 1097"
            d="M192.688,1051.419l1.955-2.616s19.17,5.045,48.541,5.157c0,0,32.548-.71,50.185-5.007l1.719,2.466-.976,15.044s-14.046,12.907-50.928,12.309c0,0-30.9,1.334-49.438-12.561Z"
            transform="translate(-47.433 -481.829)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <ellipse
            id="Ellipse_242"
            data-name="Ellipse 242"
            cx="4.518"
            cy="1.649"
            rx="4.518"
            ry="1.649"
            transform="translate(190.413 597.97)"
            fill="#030504"
          />
          <path
            id="Path_1099"
            data-name="Path 1099"
            d="M224.963,1123.657s-9.581-1.453-13.012-8.237"
            transform="translate(-58.769 -521.035)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1100"
            data-name="Path 1100"
            d="M392.142,1123.332s10.108-1.565,12.677-7.957"
            transform="translate(-164.815 -521.008)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1101"
            data-name="Path 1101"
            d="M139.41,283.027s-.508-40.739,44.363-48.255"
            transform="translate(-16.077 -2.759)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1102"
            data-name="Path 1102"
            d="M431.543,283.027s.508-40.739-44.363-48.255"
            transform="translate(-161.894 -2.759)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1103"
            data-name="Path 1103"
            d="M494.686,352.043l1.751,2.624,1.583,51.678-3.55,3.5Z"
            transform="translate(-225.037 -71.775)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1104"
            data-name="Path 1104"
            d="M134.681,352.043l-1.751,2.624-1.583,51.678,3.55,3.5Z"
            transform="translate(-11.332 -71.775)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <g id="Group_1217" data-name="Group 1217" transform="translate(201.928 387.004)">
            <line
              id="Line_86"
              data-name="Line 86"
              y1="59.925"
              x2="0.43"
              transform="translate(35.87 0.143)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <line
              id="Line_87"
              data-name="Line 87"
              y2="59.399"
              transform="translate(11.383)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <line
              id="Line_88"
              data-name="Line 88"
              x2="47.491"
              transform="translate(0 20.948)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <path
              id="Path_1108"
              data-name="Path 1108"
              d="M361.567,766.753v-3.061s1.6,4.639.335,8.465Z"
              transform="translate(-348.749 -701.04)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <path
              id="Path_1109"
              data-name="Path 1109"
              d="M414.311,771.87s-1.865-6.182,0-8.178Z"
              transform="translate(-379.302 -701.04)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <path
              id="Path_1110"
              data-name="Path 1110"
              d="M361.567,763.692s8.776,3.754,22.191,0"
              transform="translate(-348.749 -701.04)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
          </g>
          <g id="Group_1218" data-name="Group 1218" transform="translate(148.202 387.004)">
            <line
              id="Line_89"
              data-name="Line 89"
              y1="59.925"
              x2="0.43"
              transform="translate(35.87 0.143)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <line
              id="Line_90"
              data-name="Line 90"
              y2="59.399"
              transform="translate(11.383)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <line
              id="Line_91"
              data-name="Line 91"
              x2="47.491"
              transform="translate(0 20.948)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <path
              id="Path_1114"
              data-name="Path 1114"
              d="M231,766.753v-3.061s1.6,4.639.335,8.465Z"
              transform="translate(-218.182 -701.04)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <path
              id="Path_1115"
              data-name="Path 1115"
              d="M283.743,771.87s-1.865-6.182,0-8.178Z"
              transform="translate(-248.734 -701.04)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <path
              id="Path_1116"
              data-name="Path 1116"
              d="M231,763.692s8.776,3.754,22.191,0"
              transform="translate(-218.182 -701.04)"
              fill="none"
              stroke="#030504"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
          </g>
        </g>
        <g id="Group_1220" data-name="Group 1220" transform="translate(191)">
          <path
            id="Path_1117"
            data-name="Path 1117"
            d="M395.76,331.493c-.392-7.833-8.217-14.09-17.84-14.09s-17.448,6.257-17.84,14.09Z"
            transform="translate(10669 1919.213)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.486"
            opacity="0.7"
          />
          <ellipse
            id="Ellipse_243"
            data-name="Ellipse 243"
            cx="16.941"
            cy="3.264"
            rx="16.941"
            ry="3.264"
            transform="translate(11029.979 2253.993)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.404"
            opacity="0.7"
          />
          <path
            id="Path_1119"
            data-name="Path 1119"
            d="M403.9,313.738v3.8h-4.452l-3.529,3.529h20.9l-3.842-3.842h-4.195v-3.489Z"
            transform="translate(10669 1919.213)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.486"
          />
          <path
            id="Path_1120"
            data-name="Path 1120"
            d="M428.927,310.168v19.764l3.692-1.954h22.589v-8.9S456.511,311.036,428.927,310.168Z"
            transform="translate(10669 1919.213)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.5"
          />
        </g>
      </g>
      <g id="Group_268" data-name="Group 268" transform="translate(668.339 -3.147)" opacity="0.676">
        <g id="Group_266" data-name="Group 266">
          <line
            id="Line_14"
            data-name="Line 14"
            x1="33.718"
            transform="translate(28.013 121.839)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <line
            id="Line_15"
            data-name="Line 15"
            x1="33.718"
            transform="translate(59.057 121.839)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <g id="Group_264" data-name="Group 264">
            <circle
              id="Ellipse_28"
              data-name="Ellipse 28"
              cx="4.01"
              cy="4.01"
              r="4.01"
              transform="translate(0.094 154.639)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <circle
              id="Ellipse_29"
              data-name="Ellipse 29"
              cx="4.01"
              cy="4.01"
              r="4.01"
              transform="translate(11.774 157.083)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_200"
              data-name="Path 200"
              d="M-.821,148.93V128.242s-.651-3.611,3.611-3.611H23.125v21.747s.217,4.887-4.887,4.887H-.857Z"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_201"
              data-name="Path 201"
              d="M-4.242,150.5V126.722s-1.2-4.883,4.883-4.883H22.8v25.625s.326,3.8-4.561,3.8H-4.338Z"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_202"
              data-name="Path 202"
              d="M-.821,147.138,24.1,152.893v4.19L-.857,151.265Z"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_16"
              data-name="Line 16"
              x1="33.359"
              transform="translate(28.372 126.124)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_17"
              data-name="Line 17"
              x2="27.747"
              transform="translate(33.333 155.608)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_18"
              data-name="Line 18"
              x2="27.747"
              transform="translate(33.333 165.104)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_19"
              data-name="Line 19"
              x2="27.747"
              transform="translate(33.333 167.011)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_20"
              data-name="Line 20"
              x2="27.747"
              transform="translate(33.333 169.183)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
          <g id="Group_265" data-name="Group 265">
            <circle
              id="Ellipse_30"
              data-name="Ellipse 30"
              cx="4.01"
              cy="4.01"
              r="4.01"
              transform="translate(112.853 154.639)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <circle
              id="Ellipse_31"
              data-name="Ellipse 31"
              cx="4.01"
              cy="4.01"
              r="4.01"
              transform="translate(101.174 157.083)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_205"
              data-name="Path 205"
              d="M121.789,148.93V128.242s.652-3.611-3.611-3.611H97.843v21.747s-.217,4.887,4.887,4.887h19.095Z"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_206"
              data-name="Path 206"
              d="M125.21,150.5V126.722s1.2-4.883-4.883-4.883H98.169v25.625s-.326,3.8,4.561,3.8h22.576Z"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <path
              id="Path_207"
              data-name="Path 207"
              d="M121.789,147.138l-24.923,5.756v4.19l24.959-5.819Z"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_21"
              data-name="Line 21"
              x2="33.359"
              transform="translate(59.237 126.124)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_22"
              data-name="Line 22"
              x1="27.747"
              transform="translate(59.889 155.608)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_23"
              data-name="Line 23"
              x1="27.747"
              transform="translate(59.889 165.104)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_24"
              data-name="Line 24"
              x1="27.747"
              transform="translate(59.889 167.011)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
            <line
              id="Line_25"
              data-name="Line 25"
              x1="27.747"
              transform="translate(59.889 169.183)"
              fill="none"
              stroke="#2c2c2c"
              stroke-miterlimit="10"
              stroke-width="1"
            />
          </g>
        </g>
        <g id="Group_267" data-name="Group 267">
          <line
            id="Line_26"
            data-name="Line 26"
            y1="7.52"
            transform="translate(71.473 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_27"
            data-name="Line 27"
            y1="7.52"
            transform="translate(69.192 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_28"
            data-name="Line 28"
            y1="7.52"
            transform="translate(66.912 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_29"
            data-name="Line 29"
            y1="7.52"
            transform="translate(69.631 170.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_30"
            data-name="Line 30"
            y1="7.52"
            transform="translate(62.351 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_31"
            data-name="Line 31"
            y1="7.52"
            transform="translate(60.07 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_32"
            data-name="Line 32"
            y1="7.52"
            transform="translate(57.789 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_33"
            data-name="Line 33"
            y1="7.52"
            transform="translate(55.509 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <line
            id="Line_34"
            data-name="Line 34"
            y1="7.52"
            transform="translate(53.228 152.759)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
          <path
            id="Path_211"
            data-name="Path 211"
            d="M50.948,152.759v16.548s-5.7,1.14-4.887,4.887,4.724,5.049,9.448,1.791"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1.036"
          />
        </g>
      </g>

      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['bull_bar'] || ''"
        [attr.data-name]="'major_options.bull_bar' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="121"
          height="24"
          rx="12"
          transform="translate(446 139)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Bull_Bar-2"
          data-name="Bull Bar"
          transform="translate(495 155)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.bull_bar' | translate }}</tspan>
        </text>
        <g id="Arrow">
          <path
            id="Path_214"
            data-name="Path 214"
            d="M6251.706,979.656l-76.024,19.306H6157"
            transform="translate(-5592.002 -845.962)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_215"
            data-name="Path 215"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(656.703 131)"
            fill="#333"
          />
        </g>
        <g class="parts" id="Bull_Bar-3" data-name="Bull Bar">
          <path
            id="Path_203"
            data-name="Path 203"
            d="M22.8,121.839v-3.7s-.326-1.995,2-1.995,2.918.855,2.918,1.805c0,.19.115,1.657.3,3.887.742,8.969,2.6,30.272,2.6,30.272l1.955,3.5H24.691Z"
            transform="translate(634.339 5.853)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_204"
            data-name="Path 204"
            d="M24.1,157.083v12.1h9.231V155.608H24.691Z"
            transform="translate(634.339 5.853)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_208"
            data-name="Path 208"
            d="M98.169,121.839v-3.7s.326-1.995-1.995-1.995-2.919.855-2.919,1.805c0,.19-.115,1.657-.3,3.887-.742,8.969-2.606,30.272-2.606,30.272l-1.955,3.5h7.883Z"
            transform="translate(634.339 5.853)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_209"
            data-name="Path 209"
            d="M96.866,157.083v12.1H87.635V155.608h8.642Z"
            transform="translate(634.339 5.853)"
            fill="none"
            stroke="#2c2c2c"
            stroke-miterlimit="10"
            stroke-width="1"
          />
        </g>
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 139)"
          fill="#f9b22a"
        />
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(550 154)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['electric_winch'] || ''"
        [attr.data-name]="'major_options.electric_winch' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="121"
          height="24"
          rx="12"
          transform="translate(446 174)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Electric_Winch-2"
          data-name="Electric Winch"
          transform="translate(460 190)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.electric_winch' | translate }}
          </tspan>
        </text>
        <g id="Arrow-2" data-name="Arrow">
          <path
            id="Path_212"
            data-name="Path 212"
            d="M6272.706,979.656l-92.882,19.306H6157"
            transform="translate(-5589.002 -813.962)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_213"
            data-name="Path 213"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(680.703 162)"
            fill="#333"
          />
        </g>
        <path
          class="parts"
          id="Electric_Winch-3"
          data-name="Electric Winch"
          d="M43.943,152.366v3.747h3.1v4.561H76.2v-8.308H43.943Z"
          transform="translate(634.339 5.853)"
          fill="none"
          stroke="#2c2c2c"
          stroke-miterlimit="10"
          stroke-width="1"
        />
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 174)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(550 189)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_single_screen'] || ''"
        [attr.data-name]="'major_options.frt_single_screen' | translate"
        transform="translate(34 -9)"
      >
        <path
          id="Path_1118"
          data-name="Path 1118"
          d="M399.11,333.681l.869,5.43h12.814l1.086-5.43Z"
          transform="translate(283.79 7.775)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.486"
        />
        <rect
          class="parts"
          id="FRT_Single_Screen-2"
          data-name="FRT Single Screen"
          width="12.971"
          height="2.769"
          transform="translate(683.671 347.7)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.486"
        />
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="150"
          height="24"
          rx="12"
          transform="translate(417 292)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Single_Screen-3"
          data-name="FRT Single Screen"
          transform="translate(439 308)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.frt_single_screen' | translate }}
          </tspan>
        </text>
        <g id="Arrow-3" data-name="Arrow">
          <path
            id="Path_123"
            data-name="Path 123"
            d="M6280.149,1027.192l.988-1.527-97.885-46.009H6157"
            transform="translate(-5590 -675.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_172"
            data-name="Path 172"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(689 348)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 292)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(550 307)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['fixed_side_steps'] || ''"
        [attr.data-name]="'major_options.fixed_side_steps' | translate"
        transform="translate(34 -9)"
      >
        <path
          class="parts"
          id="Fixed_Side_Steps-2"
          data-name="Fixed Side Steps"
          d="M327.056,402.151h5.213v-27.99l-5.213,2.171Z"
          transform="translate(282.79 12.775)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.431"
        />
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="137"
          height="24"
          rx="12"
          transform="translate(430 398)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Fixed_Side_Steps-3"
          data-name="Fixed Side Steps"
          transform="translate(447 414)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.fixed_side_steps' | translate }}
          </tspan>
        </text>
        <g id="Arrow-4" data-name="Arrow">
          <path
            id="Path_177"
            data-name="Path 177"
            d="M6197.7,979.656l-32.675,2.67H6157"
            transform="translate(-5591 -571.327)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_178"
            data-name="Path 178"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(606.703 405.33)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 398)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(550 413)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['dual_sun_roof'] || ''"
        [attr.data-name]="'major_options.dual_sun_roof' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="129"
          height="24"
          rx="12"
          transform="translate(438 438)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Dual_Sun_Roof-2"
          data-name="Dual Sun Roof"
          transform="translate(461 454)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.dual_sun_roof' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 438)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(550 453)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_multi_screen'] || ''"
        [attr.data-name]="'major_options.rr_multi_screens' | translate"
        transform="translate(34 -9)"
      >
        <g class="parts" id="RR_Multi_Screens-2" data-name="RR Multi Screens">
          <path
            id="Path_163"
            data-name="Path 163"
            d="M364.5,417.327l.869,5.43h12.814l1.086-5.43Z"
            transform="translate(291.837 11.994)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.486"
          />
          <path
            id="Path_164"
            data-name="Path 164"
            d="M428.927,417.327l.869,5.43H442.61l1.086-5.43Z"
            transform="translate(282.317 11.994)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.486"
          />
        </g>
        <g id="Arrow-5" data-name="Arrow">
          <path
            id="Path_182"
            data-name="Path 182"
            d="M6258.7,979.656l-81.643,54H6157"
            transform="translate(-5592 -543.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_181"
            data-name="Path 181"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(663.703 430)"
            fill="#333"
          />
        </g>
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="150"
          height="24"
          rx="12"
          transform="translate(417 478)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Multi_Screens-3"
          data-name="RR Multi Screens"
          transform="translate(444 494)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.rr_multi_screens' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 478)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(550 493)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['panoramic_sunroof'] || ''"
        [attr.data-name]="'major_options.panorama_sunroof' | translate"
        transform="translate(34 -9)"
      >
        <rect
          class="parts"
          id="Panorama_Sunroof-2"
          data-name="Panorama Sunroof"
          width="23.103"
          height="49.944"
          rx="6"
          transform="translate(677.043 452.829)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="148"
          height="24"
          rx="12"
          transform="translate(419 518)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Panorama_Sunroof-3"
          data-name="Panorama Sunroof"
          transform="translate(436 534)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.panorama_sunroof' | translate }}
          </tspan>
        </text>
        <g id="Arrow-6" data-name="Arrow">
          <path
            id="Path_183"
            data-name="Path 183"
            d="M6284.872,979.656l-102.65,51H6157"
            transform="translate(-5590 -499.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_184"
            data-name="Path 184"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(690.703 477)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 518)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(550 533)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['tow_hook'] || ''"
        [attr.data-name]="'major_options.tow_hook' | translate"
        transform="translate(34 -9)"
      >
        <path
          class="parts"
          id="Tow_Hook-2"
          data-name="Tow Hook"
          d="M0,0,1.738-.46V4.778H0Z"
          transform="translate(733.316 579.334)"
          fill="none"
          stroke="#1a1818"
          stroke-width="0.486"
        />
        <path
          id="Path_168"
          data-name="Path 168"
          d="M444.395,577.752v.978a1.444,1.444,0,0,0-1.615,1.615c0,1.806,3.108,2.294,3.19.421"
          transform="translate(289.79 6.713)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.486"
        />
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="100"
          height="24"
          rx="12"
          transform="translate(826 614)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Tow_Hook-3"
          data-name="Tow Hook"
          transform="translate(853 630)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.tow_hook' | translate }}</tspan>
        </text>
        <g id="Arrow-7" data-name="Arrow">
          <path
            id="Path_187"
            data-name="Path 187"
            d="M85.9,40.441,16.174,0H0"
            transform="translate(823.3 628.448) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_186"
            data-name="Path 186"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(735 587)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 614)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(832 629)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_spoiler'] || ''"
        [attr.data-name]="'major_options.rr_spoiler' | translate"
        transform="translate(34 -9)"
      >
        <path
          class="parts"
          id="RR_Spoiler-2"
          data-name="RR Spoiler"
          d="M161.76,1072.506s6.386,24.327,63.222,24.327,63.451-21.823,64.628-24.327a3.269,3.269,0,0,0-.1.711,17.357,17.357,0,0,1-.468,1.957,23.193,23.193,0,0,1-1.089,2.915,26.759,26.759,0,0,1-1.962,3.586,30.047,30.047,0,0,1-3.087,3.969,34.765,34.765,0,0,1-4.465,4.063,42.563,42.563,0,0,1-6.095,3.871,55.263,55.263,0,0,1-7.977,3.39,75.206,75.206,0,0,1-10.111,2.622,105.345,105.345,0,0,1-12.5,1.566c-2.931.2-5.869.3-8.807.314-4.367.022-8.735.022-13.1.126q-3.172.076-6.345-.044-4.008-.149-8-.608a88.014,88.014,0,0,1-8.982-1.5,69.993,69.993,0,0,1-9.3-2.732,53.242,53.242,0,0,1-8.949-4.294,41.477,41.477,0,0,1-7.932-6.187,36.436,36.436,0,0,1-6.248-8.412A37.756,37.756,0,0,1,161.76,1072.506Z"
          transform="translate(463.178 -518.484)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="114"
          height="24"
          rx="12"
          transform="translate(826 572)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Spoiler-3"
          data-name="RR Spoiler"
          transform="translate(853 588)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.rr_spoiler' | translate }}
          </tspan>
        </text>
        <g id="Arrow-8" data-name="Arrow">
          <path
            id="Path_188"
            data-name="Path 188"
            d="M111.03,12.819,21.394,2.755H0"
            transform="translate(826.142 585.823) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_189"
            data-name="Path 189"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(711.703 571.783)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 572)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(832 587)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_electric_seats'] || ''"
        [attr.data-name]="'major_options.rr_electric_seat' | translate"
        transform="translate(34 -9)"
      >
        <rect
          class="parts"
          id="RR_Electric_Seat-2"
          data-name="RR Electric Seat"
          width="102.593"
          height="49.944"
          rx="8"
          transform="translate(637.399 452.829)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="147"
          height="24"
          rx="12"
          transform="translate(826 494)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Electric_Seat-3"
          data-name="RR Electric Seat"
          transform="translate(853 510)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.rr_electric_seat' | translate }}
          </tspan>
        </text>
        <g id="Arrow-9" data-name="Arrow">
          <path
            id="Path_190"
            data-name="Path 190"
            d="M103.069,20.793,19.75,0H0"
            transform="translate(829.521 505.113) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_533"
            data-name="Path 533"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(721.703 483.045)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(826 494)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(832 509)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['retractable_side_step'] || ''"
        [attr.data-name]="'major_options.retractable_side_step' | translate"
        transform="translate(34 -9)"
      >
        <rect
          class="parts"
          id="Retractable_Side_Step-2"
          data-name="Retractable Side Step"
          width="6.346"
          height="79.152"
          rx="3.173"
          transform="translate(763.244 368.669)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="161"
          height="24"
          rx="12"
          transform="translate(823 419)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Retractable_Side_Step-3"
          data-name="Retractable Side Step"
          transform="translate(853 434)"
          fill="#242e3a"
          font-size="11"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.retractable_side_step' | translate }}
          </tspan>
        </text>
        <g id="Arrow-10" data-name="Arrow">
          <path
            id="Path_194"
            data-name="Path 194"
            d="M52.327,4.914l-1.086-.127L10.321,0H0"
            transform="translate(823 432) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_195"
            data-name="Path 195"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(766.371 425)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 419)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(829 434)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['gps'] || ''"
        [attr.data-name]="'major_options.gps' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(823 379)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="GPS-2"
          data-name="GPS"
          transform="translate(853 395)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.gps' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 379)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(829 394)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['sun_roof'] || ''"
        [attr.data-name]="'major_options.sunroof' | translate"
        transform="translate(34 -9)"
      >
        <g class="parts" id="Sunroof-2" data-name="Sunroof">
          <rect
            id="Rectangle_65"
            data-name="Rectangle 65"
            width="57.339"
            height="21.286"
            rx="9.219"
            transform="translate(662.843 381.973)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.431"
          />
          <rect
            id="Rectangle_66"
            data-name="Rectangle 66"
            width="57.339"
            height="18.191"
            rx="8.522"
            transform="translate(662.843 410.51)"
            fill="none"
            stroke="#1a1818"
            stroke-miterlimit="10"
            stroke-width="0.398"
          />
        </g>
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(823 311)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Sunroof-3"
          data-name="Sunroof"
          transform="translate(853 327)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.sunroof' | translate }}</tspan>
        </text>
        <g id="Arrow-11" data-name="Arrow">
          <path
            id="Path_199"
            data-name="Path 199"
            d="M128.78,4.465,23.285,69.952H0"
            transform="translate(823.732 395.94) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_198"
            data-name="Path 198"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(690.703 391)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 311)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(829 326)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['refrigerator'] || ''"
        [attr.data-name]="'major_options.refrigerator' | translate"
        transform="translate(34 -9)"
      >
        <path
          class="parts"
          id="Refrigerator_2"
          data-name="Refrigerator "
          d="M399.11,333.681l.941,18.468h13.877l1.176-18.468Z"
          transform="translate(283.79 65.246)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.486"
        />
        <g id="Group_254" data-name="Group 254" transform="translate(822.838 346.146)">
          <rect
            id="Rectangle_38-14"
            data-name="Rectangle 38"
            width="115"
            height="24"
            rx="12"
            transform="translate(0.162 -0.146)"
            fill="#242e3a"
            opacity="0.07"
          />
        </g>
        <text
          id="Refrigerator_3"
          data-name="Refrigerator "
          transform="translate(853 362)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.refrigerator' | translate }}
          </tspan>
        </text>
        <g id="Arrow-12" data-name="Arrow">
          <path
            id="Path_538"
            data-name="Path 538"
            d="M132.484,6.507,24.36,51.963H0"
            transform="translate(824.186 410.845) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_539"
            data-name="Path 539"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(687.752 404)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 346)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(829 361)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['cool_box'] || ''"
        [attr.data-name]="'major_options.cool_box' | translate"
        transform="translate(34 -9)"
      >
        <path
          class="parts"
          id="Cool_Box-2"
          data-name="Cool Box"
          d="M426.261,331.716a3.755,3.755,0,0,1,1.3-.933l1.765-1.008,3.616-2.067h22.272v5.538h-7.53v-2.769h-8.47v2.769H427.85c-.416,0-.832,0-1.25,0-.457-.005-.618-.488-.575-.884A1.355,1.355,0,0,1,426.261,331.716Z"
          transform="translate(283.79 7.775)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(823 271)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Cool_Box-3"
          data-name="Cool Box"
          transform="translate(853 287)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.cool_box' | translate }}</tspan>
        </text>
        <g id="Arrow-13" data-name="Arrow">
          <path
            id="Path_197"
            data-name="Path 197"
            d="M84.111,7.606,15.268,62.334H0"
            transform="translate(822.836 344.649) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_196"
            data-name="Path 196"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(734.698 335)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 271)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(829 286)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_eclectric_seat'] || ''"
        [attr.data-name]="'major_options.frt_electric_seat' | translate"
        transform="translate(34 -9)"
      >
        <g class="parts" id="FRT_Electric_Seat-2" data-name="FRT Electric Seat">
          <path
            id="Path_1105"
            data-name="Path 1105"
            d="M330.9,624.58l.335-4.878s-.287-2.3,3.2-4.3l7.031-3.73H367s8.25,3.921,8.824,4.854,1.435.968,1.506,3.049.574,14.455.574,14.455.143,14.2-1.794,16.069c0,0,1.316.024.789,4.185s-2.3,23.387-11.478,22.861V682.4a66.393,66.393,0,0,1-11.813,1.052,51.392,51.392,0,0,1-10.043-.765l-.335-5.4s-3.874-.526-5.261-2.248-4.4-7.15-6.193-20.852c-.478-3.659.693-3.946.693-3.946S329.222,634.576,330.9,624.58Z"
            transform="translate(363.921 -247.272)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1111"
            data-name="Path 1111"
            d="M200.328,624.58l.335-4.878s-.287-2.3,3.2-4.3l7.03-3.73h25.539s8.25,3.921,8.824,4.854,1.434.968,1.506,3.049.574,14.455.574,14.455.144,14.2-1.793,16.069c0,0,1.315.024.789,4.185s-2.3,23.387-11.478,22.861V682.4a66.391,66.391,0,0,1-11.813,1.052A51.4,51.4,0,0,1,213,682.688l-.335-5.4s-3.874-.526-5.261-2.248-4.4-7.15-6.194-20.852c-.478-3.659.694-3.946.694-3.946S198.654,634.576,200.328,624.58Z"
            transform="translate(440.762 -247.272)"
            fill="none"
            stroke="#030504"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
        <rect
          id="Rectangle_98"
          data-name="Rectangle 98"
          width="147"
          height="24"
          rx="12"
          transform="translate(823 231)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Electric_Seat-3"
          data-name="FRT Electric Seat"
          transform="translate(853 247)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.frt_electric_seat' | translate }}
          </tspan>
        </text>
        <g id="Arrow-14" data-name="Arrow">
          <path
            id="Path_531"
            data-name="Path 531"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(709.703 368)"
            fill="#333"
          />
          <path
            id="Path_532"
            data-name="Path 532"
            d="M10671.133,2082h-54.4l-55.392,127.3"
            transform="translate(-9848 -1839)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 231)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(829 246)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_sensor'] || ''"
        [attr.data-name]="'major_options.frt_sensor' | translate"
        transform="translate(34 -9)"
      >
        <path
          class="parts"
          id="FRT_Sensor-2"
          data-name="FRT Sensor"
          d="M235.951,235.362s1.832-2.829,30.94-3.372c0,0,29.213-.776,34.633,2.516l-2.275-2.05s-7.769-3.026-32.359-2.242S238.57,231.094,235.951,235.362Z"
          transform="translate(419.516 -22.705)"
          fill="none"
          stroke="#030504"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="0.5"
        />
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(823 158)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Sensor-3"
          data-name="FRT Sensor"
          transform="translate(853 174)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.frt_sensor' | translate }}
          </tspan>
        </text>
        <g id="Arrow-15" data-name="Arrow">
          <path
            id="Path_216"
            data-name="Path 216"
            d="M121.462,9.631,23.305,46.676H0"
            transform="translate(823.05 215.938) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_217"
            data-name="Path 217"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(698.482 205)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 158)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(829 173)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_camera'] || ''"
        [attr.data-name]="'major_options.frt_camera' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="121"
          height="24"
          rx="12"
          transform="translate(446 215)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Camera-2"
          data-name="FRT Camera"
          transform="translate(471 231)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.frt_camera' | translate }}
          </tspan>
        </text>
        <g id="Arrow-16" data-name="Arrow">
          <path
            id="Path_544"
            data-name="Path 544"
            d="M6278.9,958.422l-104.6,14.343H6157"
            transform="translate(-5590 -745.765)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_547"
            data-name="Path 547"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(686.703 208.428)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 215)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(550 230)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g
          class="parts"
          id="FRT_Camera-3"
          data-name="FRT Camera"
          transform="translate(690 207)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        >
          <circle cx="2" cy="2" r="2" stroke="none" />
          <circle cx="2" cy="2" r="1.75" fill="none" />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_side_sensor'] || ''"
        [attr.data-name]="'major_options.frt_side_sensor' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_99"
          data-name="Rectangle 99"
          width="138"
          height="24"
          rx="12"
          transform="translate(823 191)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Side_Sensor-2"
          data-name="FRT Side Sensor"
          transform="translate(853 207)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.frt_side_sensor' | translate }}
          </tspan>
        </text>
        <g id="Arrow-17" data-name="Arrow">
          <path
            id="Path_542"
            data-name="Path 542"
            d="M76.542,8.232,14.2,24.744H0"
            transform="translate(822.667 229.009) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_543"
            data-name="Path 543"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(741.703 219)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 191)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(829 206)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <path
          class="parts"
          id="FRT_Side_Sensor-3"
          data-name="FRT Side Sensor"
          d="M10585.985,2006.214s-1.311,3.854-1.6,4.706c4.054,1.167,10.105,8.651,10.105,8.651a25.079,25.079,0,0,1,5.2-1.33C10597.35,2013.522,10585.985,2006.214,10585.985,2006.214Z"
          transform="translate(-9848 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['auto_rr_window_curtain'] || ''"
        [attr.data-name]="'major_options.rr_retractable_curtain' | translate"
        transform="translate(34 -8)"
      >
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="159"
          height="24"
          rx="12"
          transform="translate(823 531)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Retractable_curtain-2"
          data-name="RR Retractable curtain"
          transform="translate(853 547)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.rr_retractable_curtain' | translate }}
          </tspan>
        </text>
        <g id="Arrow-18" data-name="Arrow">
          <path
            id="Path_541"
            data-name="Path 541"
            d="M120.289,16.634,23.727,0H0"
            transform="translate(829.652 543.136) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_540"
            data-name="Path 540"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(705.703 525)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 531)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(829 546)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <path
          class="parts"
          id="RR_Retractable_curtain-3"
          data-name="RR Retractable curtain"
          d="M10497.231,2295.5l-2.46,35.419h84.125l-2.658-35.419Z"
          transform="translate(-9848 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1127"
          data-name="Path 1127"
          d="M10505.821,2295.5l-1.68,35.237"
          transform="translate(-9848 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1128"
          data-name="Path 1128"
          d="M10505.821,2295.5v34.856"
          transform="translate(-9838 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1129"
          data-name="Path 1129"
          d="M10505.821,2295.5v34.856"
          transform="translate(-9828 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1130"
          data-name="Path 1130"
          d="M10505.821,2295.5v34.856"
          transform="translate(-9818 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1131"
          data-name="Path 1131"
          d="M10505.821,2295.5v34.856"
          transform="translate(-9808 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1132"
          data-name="Path 1132"
          d="M10505.821,2295.5v34.856"
          transform="translate(-9798 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <path
          id="Path_1133"
          data-name="Path 1133"
          d="M10505.821,2295.5s1.471,26.332,1.471,35.046"
          transform="translate(-9788 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_camera'] || ''"
        [attr.data-name]="'major_options.rr_camera' | translate"
        transform="translate(26.936 -8.083)"
      >
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="121"
          height="24"
          rx="12"
          transform="translate(638 634.083)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Camera-2"
          data-name="RR Camera"
          transform="translate(661 650.083)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.rr_camera' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(736 634.083)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(742 649.083)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g id="Arrow-19" data-name="Arrow">
          <path
            id="Path_549"
            data-name="Path 549"
            d="M10559.7,2409v48.083"
            transform="translate(-9862 -1823)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_548"
            data-name="Path 548"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(695 583)"
            fill="#333"
          />
        </g>
        <g
          class="parts"
          id="RR_Camera-3"
          data-name="RR Camera"
          transform="translate(693 582)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        >
          <circle cx="2" cy="2" r="2" stroke="none" />
          <circle cx="2" cy="2" r="1.75" fill="none" />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_sensor'] || ''"
        [attr.data-name]="'major_options.rr_sensor' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="109"
          height="24"
          rx="12"
          transform="translate(458 612)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Sensor-2"
          data-name="RR Sensor"
          transform="translate(481 628)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'major_options.rr_sensor' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 612)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(550 627)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <path
          class="parts"
          id="RR_Sensor-3"
          data-name="RR Sensor"
          d="M10507.355,2370.928c-.782-1.035.584,2,.654,2.126s22.188,1.649,22.188,1.649.338-1.834,0-1.649c-.019.01-1.712,0-1.712,0S10508.095,2371.906,10507.355,2370.928Z"
          transform="translate(-9848 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <g id="Arrow-20" data-name="Arrow">
          <path
            id="Path_179"
            data-name="Path 179"
            d="M6266.74,977.573l-83.368,40.083H6157"
            transform="translate(-5591 -391.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_185"
            data-name="Path 185"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(672.703 582.917)"
            fill="#333"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['rr_side_sensor'] || ''"
        [attr.data-name]="'major_options.rr_side_sensor' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="143"
          height="24"
          rx="12"
          transform="translate(424 578)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="RR_Side_Sensor-2"
          data-name="RR Side Sensor"
          transform="translate(454 594)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.rr_side_sensor' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 578)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(550 593)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <path
          class="parts"
          id="RR_Side_Sensor-3"
          data-name="RR Side Sensor"
          d="M10467.087,2340.313c.8.009,5.894,0,5.894,0v3.485a47.722,47.722,0,0,0,10.83,16.38c1.37,1.015-2.057,1.984-2.417,3.711C10476.3,2360.254,10468.654,2351.365,10467.087,2340.313Z"
          transform="translate(-9848 -1790)"
          fill="none"
          stroke="#000"
          stroke-width="0.5"
        />
        <g id="Arrow-21" data-name="Arrow">
          <path
            id="Path_546"
            data-name="Path 546"
            d="M6219.367,964.87l-47.238,25.786H6157"
            transform="translate(-5597 -401.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_545"
            data-name="Path 545"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(620.543 560)"
            fill="#333"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['seat_heaters'] || ''"
        [attr.data-name]="'major_options.seat_heaters' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="116"
          height="24"
          rx="12"
          transform="translate(451 337)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Seat_Heaters-2"
          data-name="Seat Heaters"
          transform="translate(467 353)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.seat_heaters' | translate }}
          </tspan>
        </text>
        <g id="Arrow-22" data-name="Arrow">
          <path
            id="Path_174"
            data-name="Path 174"
            d="M6245.7,1019.656l-71.206-40H6157"
            transform="translate(-5591 -628.656)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_173"
            data-name="Path 173"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(651.703 388)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 337)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(550 352)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g class="parts" id="Seat_Heaters-3" data-name="Seat Heaters">
          <g
            id="Rectangle_214"
            data-name="Rectangle 214"
            transform="translate(652 385)"
            fill="none"
            stroke="#000"
            stroke-width="0.3"
          >
            <rect width="25" height="21" stroke="none" />
            <rect x="0.15" y="0.15" width="24.7" height="20.7" fill="none" />
          </g>
          <g
            id="Rectangle_215"
            data-name="Rectangle 215"
            transform="translate(706 385)"
            fill="none"
            stroke="#000"
            stroke-width="0.3"
          >
            <rect width="25" height="21" stroke="none" />
            <rect x="0.15" y="0.15" width="24.7" height="20.7" fill="none" />
          </g>
        </g>
        <line
          id="Line_4"
          data-name="Line 4"
          x2="20.43"
          transform="translate(653.51 388.706)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_5"
          data-name="Line 5"
          x2="20.43"
          transform="translate(653.51 393.05)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_6"
          data-name="Line 6"
          x2="20.43"
          transform="translate(653.51 397.394)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_7"
          data-name="Line 7"
          x2="20.43"
          transform="translate(653.51 401.738)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_10"
          data-name="Line 10"
          x2="20.43"
          transform="translate(708.414 388.706)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_11"
          data-name="Line 11"
          x2="20.43"
          transform="translate(708.414 393.05)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_12"
          data-name="Line 12"
          x2="20.43"
          transform="translate(708.414 397.394)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
        <line
          id="Line_13"
          data-name="Line 13"
          x2="20.43"
          transform="translate(708.414 401.738)"
          fill="none"
          stroke="#1a1818"
          stroke-miterlimit="10"
          stroke-width="0.286"
          opacity="0.16"
        />
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp excellent"
        [id]="parts['frt_seat_massager'] || ''"
        [attr.data-name]="'major_options.frt_seat_amenities' | translate"
        transform="translate(34 -9)"
      >
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="159"
          height="24"
          rx="12"
          transform="translate(823 459)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="FRT_Seat_Amenities-2"
          data-name="FRT Seat Amenities"
          transform="translate(853 475)"
          fill="#242e3a"
          font-size="12"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'major_options.frt_seat_amenities' | translate }}
          </tspan>
        </text>
        <g id="Arrow-23" data-name="Arrow">
          <path
            id="Path_192"
            data-name="Path 192"
            d="M97.157,53.618,16.678,0H0"
            transform="translate(823 471) rotate(179)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_193"
            data-name="Path 193"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(721.703 417)"
            fill="#333"
          />
        </g>
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(823 459)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(829 474)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">5.0</tspan>
        </text>
        <g class="parts" id="FRT_Seat_Amenities-3" data-name="FRT Seat Amenities">
          <path
            id="Path_1136"
            data-name="Path 1136"
            d="M283.381,39.645s4.047-2.8,9.122,3.085h24.373c.147,0,.822-.919.973-1.06a9.215,9.215,0,0,1,1.166-.92,9.006,9.006,0,0,1,2.658-1.2c1.333-.356,4.639-.9,5.249.833a6.844,6.844,0,0,1,.107,2.979A46.9,46.9,0,0,1,324.423,54q-.276.781-.556,1.562a26.024,26.024,0,0,1-1.166,3.1c-.386.753-6.807,2.188-6.807,2.188s-19.437.319-21.4.2-7.508-2.677-7.508-2.677c-.21-.1-.528-1.119-.648-1.37-.258-.537-.517-1.073-.772-1.611-.509-1.076-1-2.161-1.419-3.276a33.316,33.316,0,0,1-1.673-7.038C282.268,43.637,281.828,40.478,283.381,39.645Z"
            transform="translate(413.745 363.267)"
            fill="none"
            stroke="#080909"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
          <path
            id="Path_1136-2"
            data-name="Path 1136"
            d="M283.381,39.645s4.047-2.8,9.122,3.085h24.373c.147,0,.822-.919.973-1.06a9.215,9.215,0,0,1,1.166-.92,9.006,9.006,0,0,1,2.658-1.2c1.333-.356,4.639-.9,5.249.833a6.844,6.844,0,0,1,.107,2.979A46.9,46.9,0,0,1,324.423,54q-.276.781-.556,1.562a26.024,26.024,0,0,1-1.166,3.1c-.386.753-6.807,2.188-6.807,2.188s-19.437.319-21.4.2-7.508-2.677-7.508-2.677c-.21-.1-.528-1.119-.648-1.37-.258-.537-.517-1.073-.772-1.611-.509-1.076-1-2.161-1.419-3.276a33.316,33.316,0,0,1-1.673-7.038C282.268,43.637,281.828,40.478,283.381,39.645Z"
            transform="translate(359.745 363.267)"
            fill="none"
            stroke="#080909"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="0.5"
          />
        </g>
      </g>
    </g>
  </svg>

  <loader [position]="{ absolute: true }" [active]="loaded"></loader>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : {{ 'exterior.qc_passed' | translate }}
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : {{ 'exterior.qc_failed' | translate }}
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="form-control credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                  style="border: none"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part change)</option>
                <option [value]="2">2 (Major Repair)</option>
                <option [value]="3">3 (Moderate Repair)</option>
                <option [value]="4">4 (Minor Repair)</option>
                <option [value]="5">5 (Good part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="
                    !vehicleStatus &&
                    ((editableRole.includes(role) && role !== 'estimator') ||
                      ['qc', 'evaluator'].includes(role))
                  "
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="
            !vehicleStatus &&
            ((editableRole.includes(role) && role !== 'estimator') ||
              ['qc', 'evaluator'].includes(role))
          "
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn-primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
